import { useParams } from 'react-router-dom'
import { NavBar } from '../../../layout'
import { PatientPageHeader } from '../../../layout/PatientLayout/PatientPageNavBar/PatientPageHeader'
import { getDisplayedName } from '../../../../misc/patient.utilities'
import { PatientNavBarProps } from './PatientTransversalNavigationNavBar.model'
import { useGoBack } from '../../../../hooks/utils'

export const PatientTransversalNavigationPageNavBar = ({ patient }: PatientNavBarProps) => {
  const { patientId } = useParams<'patientId'>()
  const goBack = useGoBack(`/patients/${patientId ?? ''}`)
  const patientFullName = patient ? getDisplayedName(patient) : null

  if (!patient) {
    return <NavBar onBackButtonClick={goBack}>Chargement...</NavBar>
  }

  return (
    <NavBar
      onBackButtonClick={goBack}
      backButtonTitle={
        patientFullName
          ? `Retour vers la page patient "${patientFullName.firstname} ${patientFullName.lastname}"`
          : undefined
      }
    >
      <PatientPageHeader patient={patient} />
    </NavBar>
  )
}
